/**
 * Converte un formato data in una stringa 'DD/MM/YYYY'.
 * @param {string | Date} inputFormat - La data di input.
 * @returns {string|null} La data formattata o null se l'input è nullo.
 */
export function convertDate(inputFormat) {
    if (!inputFormat) return null;
    const d = new Date(inputFormat);
    if (isNaN(d.getTime())) return null;

    const pad = (s) => (s < 10 ? '0' + s : s);
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
}

/**
 * Calcola lo stato di avanzamento di un laboratorio.
 * @param {object} lab - L'oggetto laboratorio.
 * @returns {{progressCount: number, progressVariant: string, progressLabel: string}} Oggetto con i valori di avanzamento.
 */
export function calculateProgress(lab) {
    if (lab.labVersion === 2 && typeof lab.progressCount === "number") {
        if (lab.status === "error") return { progressCount: 100, progressVariant: "danger", progressLabel: "Error" };
        if (lab.status === "deleted") return { progressCount: 100, progressVariant: "info", progressLabel: "Deleted" };
        if (lab.progressCount === 100) return { progressCount: 100, progressVariant: "success", progressLabel: "Complete" };
        return { progressCount: lab.progressCount, progressVariant: "primary", progressLabel: `${lab.progressCount}%` };
    }

    switch (lab.status) {
        case "creatingMaster": return { progressCount: 20, progressVariant: "primary", progressLabel: '20%' };
        case "readyMaster": return { progressCount: 60, progressVariant: "primary", progressLabel: '60%' };
        case "creatingLab": return { progressCount: 80, progressVariant: "primary", progressLabel: '80%' };
        case "updatingLab": return { progressCount: 85, progressVariant: "primary", progressLabel: '85%' };
        case "refreshingLab": return { progressCount: 90, progressVariant: "primary", progressLabel: '90%' };
        case "isRefreshing": return { progressCount: 95, progressVariant: "primary", progressLabel: '95%' };
        case "complete": return { progressCount: 100, progressVariant: "success", progressLabel: "Complete" };
        case "error": return { progressCount: 100, progressVariant: "danger", progressLabel: "Error" };
        case "dropped": return { progressCount: 100, progressVariant: "info", progressLabel: "Dropped" };
        case "deleted": return { progressCount: 100, progressVariant: "info", progressLabel: "Deleted" };
        case "deleting": return { progressCount: 100, progressVariant: "info", progressLabel: "Deleting" };
        default: return { progressCount: 0, progressVariant: "secondary", progressLabel: "N/A" };
    }
}

/**
 * Trova la prossima attività pianificata.
 * @param {Array} schedulerLab - Array di attività pianificate.
 * @returns {string|null} La data della prossima attività o null.
 */
export function formatNextActivity(schedulerLab = []) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const futureActivities = schedulerLab
        .map(activity => ({ ...activity, startDate: new Date(activity.start) }))
        .filter(activity => activity.startDate >= today)
        .sort((a, b) => a.startDate - b.startDate);

    if (futureActivities.length > 0) {
        return futureActivities[0].startDate.toLocaleString();
    }
    return null;
}
